module.exports = __webpack_public_path__ + "static/img/solution_banner3.e026d12a.png";